import {
    SetTaskListFiltersRequest,
    SetTaskListFiltersResponse,
} from "@lifeat/shared/task-management/TaskFilterFunctionContracts";
import { userTaskDataCollection } from "@lifeat/shared/task-management/TaskManagementTypes";
import { logError } from "@service/ConsoleLoggerService";
import { FirestoreService } from "@service/FirestoreService";
import { callMonolith } from "@service/ServerlessFunctionsService";
import { FilterService } from "./FilterService";

export function TaskListFilterService(uid: string): FilterService {
    const firestore = FirestoreService();
    return {
        listenForFilters(callback) {
            return firestore.getDocumentListener(userTaskDataCollection.at(uid).node, (payload) => {
                if (payload.success) {
                    return callback({ success: true, value: payload.value?.selectedFilters?.taskListFilters });
                }
                return callback({ success: false });
            });
        },
        async setFilters(
            filters: SetTaskListFiltersRequest["filters"],
        ): Promise<SetTaskListFiltersResponse["filters"]> {
            try {
                const payload: SetTaskListFiltersRequest = { filters };
                return (await callMonolith("set-task-list-filters", payload)).filters;
            } catch (err) {
                logError(`Error setting task list filters: ${err}`);
                return null;
            }
        },
    };
}
export type TaskListFilterService = ReturnType<typeof TaskListFilterService>;
